import React from "react";
import { ArrowRight } from "lucide-react"; // arrow icon
import we from "../../../assets/whoWeAre/we.jpg";
import img1 from "../whoweare/cnc.jpg";
import suspa from "../../../assets/whoWeAre/partners/suspa.png";
import greaves from "../../../assets/whoWeAre/partners/greaves.png";
import raneNSK from "../../../assets/whoWeAre/partners/raneNSK.png";
import pha from "../../../assets/whoWeAre/partners/pha.png";
import hycom from "../../../assets/whoWeAre/partners/hycom.png";
import ucal from "../../../assets/whoWeAre/partners/ucal.png";
import yuken from "../../../assets/whoWeAre/partners/yuken.png";
import yanmar from "../../../assets/whoWeAre/partners/yanmar.png";

const PartnersSection = () => {
  const currentYear = new Date().getFullYear();

  return (
    <section className="bg-white py-16">
      {/* Top Split Images with Arrow */}
      <div className="w-full flex flex-col md:flex-row items-center justify-center gap-6">
        {/* Left Side with Heading */}
        <div className="flex flex-col items-center w-full md:w-1/2">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            IN 1981
          </h2>
          <div className="relative w-full h-[200px] md:h-[300px]">
            <img
              src={we}
              alt="Who We Are"
              className="absolute inset-0 w-full h-full object-cover px-4 md:px-8"
            />
          </div>
        </div>

        {/* Arrow in Middle */}
        <div className="hidden md:flex items-center justify-center px-4">
          <ArrowRight className="w-10 h-10 text-black" />
        </div>

        {/* Right Side with Heading */}
        <div className="flex flex-col items-center w-full md:w-1/2">
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            {currentYear}
          </h2>
          <div className="relative w-full h-[200px] md:h-[300px]">
            <img
              src={img1}
              alt="Industry"
              className="absolute inset-0 w-full h-full object-cover px-4 md:px-8"
            />
          </div>
        </div>
      </div>

      {/* Text */}
      <div className="text-center mt-10">
        <h2 className="text-2xl text-black md:text-3xl font-semibold">
          Valued Partnerships Across Industries.
        </h2>
        <p className="text-[#4a4f54] text-[16px] mt-2">
          Connect with us & let’s build something great together
        </p>
      </div>

      {/* Marquee Logos */}
      <div className="w-full mt-6 z-10 flex justify-center items-center">
        <div className="relative w-full max-w-[600px] overflow-hidden">
          <div className="marquee-track flex gap-8 items-center animate-marquee">
            {[...Array(2)].flatMap(() => (
              <>
                <img src={suspa} alt="Suspa" className="w-20 h-auto" />
                <img src={greaves} alt="Greaves" className="w-20 h-auto" />
                <img src={raneNSK} alt="Rane NSK" className="w-20 h-auto" />
                <img src={pha} alt="PHA" className="w-20 h-auto" />
                <img src={hycom} alt="Hycom" className="w-20 h-auto" />
                <img src={ucal} alt="Ucal" className="w-20 h-auto" />
                <img src={yuken} alt="Yuken" className="w-20 h-auto" />
                <img src={yanmar} alt="Yanmar" className="w-20 h-auto" />
                <img src={suspa} alt="Suspa" className="w-20 h-auto" />
                <img src={greaves} alt="Greaves" className="w-20 h-auto" />
                <img src={raneNSK} alt="Rane NSK" className="w-20 h-auto" />
                <img src={pha} alt="PHA" className="w-20 h-auto" />
                <img src={hycom} alt="Hycom" className="w-20 h-auto" />
                <img src={ucal} alt="Ucal" className="w-20 h-auto" />
                <img src={yuken} alt="Yuken" className="w-20 h-auto" />
                <img src={yanmar} alt="Yanmar" className="w-20 h-auto" />
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
